function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "inherit"
}, /*#__PURE__*/React.createElement("path", {
  d: "m70.429 214.68 9.325-85.68h-36.35c-9.229 0-16.274 8.268-14.81 17.379.322 2.006 6.736 39.05 41.835 68.301z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m404.674 417 67.643-135.285c35.118-70.235-16.021-152.715-94.383-152.715h-15.38c-7.125-64.095-59.696-129-126.15-129-43.657 0-80.943 27.8-103.79 65h63.79c8.284 0 15 6.716 15 15s-6.716 15-15 15h-78.187c-7.422 20.733-7.857 33.021-11.296 64h271.013c56.157 0 92.65 59.098 67.551 109.299l-55.782 111.563-21.207-190.862h-264.904c-5.375 48.472-1.678 14.496-24.66 228zm-144.27-114c-8.284 0-15-6.716-15-15s6.716-15 15-15h17v-34h-25c-8.284 0-15-6.716-15-15s6.716-15 15-15h40c8.284 0 15 6.716 15 15v128c0 8.284-6.716 15-15 15h-40c-8.284 0-15-6.716-15-15s6.716-15 15-15h25v-34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m77.404 447v20c0 24.813 20.187 45 45 45h228c24.813 0 45-20.187 45-45v-20z"
}));

function Svg73(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg73);
export default __webpack_public_path__ + "static/media/7_3.ed68fa85.svg";
export { ForwardRef as ReactComponent };